import styled from 'styled-components';
import { SIZING } from '../../styles/variables';
import { device } from '../../styles/devices';

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${SIZING.unit(3)};
  margin-top: ${SIZING.unit(4.5)};
  @media ${device.tablet} {
    margin-top: ${SIZING.unit(6.5)};
    margin-bottom: 12px;
  }
  @media ${device.laptop} {
    padding-top: 52px;
    margin-left: 60px;
    margin-right: 60px;
    margin-top: 0;
    margin-bottom: 32px;
  }
  @media ${device.laptopL} {
    margin-left: 96px;
    margin-right: 96px;
  }

  &.title-wrapper-alpha {
    padding: 28px 0 22px 0;
    flex-direction: column;
    gap: 8px;

    .featured-offers-amount {
      text-wrap: nowrap;
    }

    &--filters-closed {
      margin: 0 var(--Sys-PageMargin-XS, 16px);
    }

    @media (min-width: 768px) {
      margin: 0 var(--Sys-PageMargin-MD, 40px);
      flex-direction: row;
      gap: auto;
      padding: 28px 0 24px 0;

      .featured-offers-amount {
        align-self: center;
      }
    }

    @media (min-width: 1024px) {
      margin: 0 var(--Sys-Space-Relative-2XL, 40px);
      flex-direction: row;
      gap: auto;
      padding: 28px 0 24px 0;

      .featured-offers-amount {
        align-self: center;
      }

      &--filters-closed {
        margin: 0 var(--Sys-PageMargin, 60px);
      }
    }

    @media (min-width: 1440px) {
      margin: 0 var(--Sys-PageMargin-XL, 96px) 0 var(--Sys-Space-Relative-2XL, 56px);
      flex-direction: row;
      gap: auto;
      padding: 32px 0 24px 0;

      .featured-offers-amount {
        align-self: center;
      }

      &--filters-closed {
        margin: 0 var(--Sys-PageMargin, 96px);
      }
    }
  }

  .headline-alpha {
    justify-self: flex-start;
    display: flex;
    width: 100%;
    margin-top: 0;
  }
`;
